import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface TourButtonProps {
  onClick: () => void;
}

/** Small "replay the page tour" button, placed next to list-header actions. */
const TourButton: React.FC<TourButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="btn-refresh"
      onClick={onClick}
      title={t('ux.showTour') || 'Show me around this page'}
      aria-label={t('ux.showTour') || 'Show me around this page'}
    >
      <HelpCircle size={15} />
    </button>
  );
};

export default TourButton;
